<template>
  <div class="feedback-success">
    <div class="title-default">意见反馈</div>
    <div class="feedback-success-content">
      <svg class="icon icona_xiadan_chenggong" aria-hidden="true">
        <use xlink:href="#icona_xiadan_chenggong" />
      </svg>
      <div class="twenty-two">提交成功</div>
      <div class="fourteen">感谢您的反馈</div>
      <el-button class="close" @click="backFeedback()">关闭</el-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {
    backFeedback(){
      this.$router.push({ path: "/user/feedback"});
    }
  }
};
</script>

<style lang='scss' scoped>
.feedback-success {
  background: #ffffff;
  .feedback-success-content {
    padding: 30px 0 60px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .icona_xiadan_chenggong {
      width: 91px;
      height: 91px;
      color: #63cf4e;
      margin-bottom: 31px;
    }
    .twenty-two {
      font-size: 22px;
      height: 22px;
      line-height: 1;
      color: #2f3133;
    }
    .fourteen {
      font-size: 14px;
      color: #5e6066;
      height: 14px;
      line-height: 1;
      margin-top: 12px;
    }
    .close {
      width: 116px;
      height: 32px;
      background: rgba(52, 85, 211, 1);
      border-radius: 2px;
      padding: 0;
      margin-top: 30px;
      color: #ffffff;
    }
  }
}
</style>
